import { LoggerUtilsComponent } from '@proteo/core';
import { LoginInitData, LoginOutputData } from '../models/types';
import * as onfidoInitData from './identity-check-template.json';
import { getCommonLanguage } from './portal-services';
export class MfeInitData {
  private multiholderSelectorInitData: any;
  private resultsMessagesInitData: any;
  private multiholderInvitationInitData: any;
  private enrollmentInitData: any;
  private loginInitData: LoginInitData;
  private personalDataInitData: any;
  private otpInitData: any;
  private previousInfoInitData: any;
  private associatedBankingInitData: any;
  private associatedCollaboratorInitData: any;
  private nationalityInitData: any;
  private idvIdentificationInitData: any;
  private identityCheckInitData: any;
  private onboardingKYCInitData: any;
  private addressConfirmationInitData: any;
  private contractSigningInitData: any;
  private checkIdvInitData: any;
  private landingInitData: any;

  constructor() {}

  setLandingInitData(landingData: any): void {
    this.landingInitData = {
      siteKey: landingData.siteKey
    };
  }

  setOnboardingKYCInitData(identityCheckOutputData: any, dataFromRecovery = false): void {
    if (dataFromRecovery) {
      this.onboardingKYCInitData = {
        customer: {
          name: identityCheckOutputData.name,
          surname: identityCheckOutputData.surname,
          secondSurname: identityCheckOutputData.secondSurname,
          dni: sessionStorage.getItem('dni'),
          address: identityCheckOutputData.address,
          location: identityCheckOutputData.location
        },
        onfidoData: { solId: identityCheckOutputData.solId },
        recovery: true
      };
    } else {
      const jsonData: Record<string, string> = JSON.parse(identityCheckOutputData.jsonData);
      this.onboardingKYCInitData = { customer: jsonData.customer, onfidoData: identityCheckOutputData };
    }
  }

  async setMultiholderInvitationInitData(outputData: any): Promise<void> {
    this.multiholderInvitationInitData = {
      iban: outputData.iban,
      customer: outputData.customer,
      relatedOwner: outputData.relatedOwner
    };
  }

  async setAddressConfirmationInitData({
    outputData,
    dataFromRecovery = false,
    showConfirmDataGenericErrorPage = false,
    confirmData = false
  }: {
    outputData: any;
    dataFromRecovery?: boolean;
    showConfirmDataGenericErrorPage?: boolean;
    confirmData?: boolean;
  }): Promise<void> {
    if (dataFromRecovery) {
      this.addressConfirmationInitData = {
        customer: {
          name: outputData.name,
          surname: outputData.surname,
          secondSurname: outputData.secondSurname,
          dni: sessionStorage.getItem('dni'),
          address: outputData.address,
          location: outputData.location
        },
        onfidoData: { solId: outputData.solId },
        name: outputData.name,
        surname: outputData.surname,
        birthdate: outputData.birthdate,
        showConfirmDataGenericErrorPage: showConfirmDataGenericErrorPage,
        confirmData: confirmData
      };
    } else {
      this.addressConfirmationInitData = {
        customer: outputData.customer,
        onfidoData: { solId: outputData.solId },
        name: outputData.name,
        surname: outputData.surname,
        birthdate: outputData.birthdate,
        showConfirmDataGenericErrorPage: showConfirmDataGenericErrorPage,
        confirmData: confirmData
      };
    }
  }

  setContractSigningInitData(identityCheckOutputData: any, completeOnboarding = false, isSign = false): void {
    if (completeOnboarding) {
      this.contractSigningInitData = {
        iban: identityCheckOutputData.iban,
        onfidoData: { solId: identityCheckOutputData.solId }
      };
    } else {
      // if (dataFromIdentityCheck) {
      //   this.contractSigningInitData = { customer: identityCheckOutputData.customer, onfidoData: { solId: identityCheckOutputData.solId } };
      // } else {
      //   this.contractSigningInitData = identityCheckOutputData;
      // }
      this.contractSigningInitData = identityCheckOutputData;
    }
    // this.contractSigningInitData.identityCheck = dataFromIdentityCheck;
    this.contractSigningInitData.completeOnboarding = completeOnboarding;
    this.contractSigningInitData.isSign = isSign;
  }

  setResultsMessagesInitData(data: any): void {
    this.resultsMessagesInitData = data;
  }

  setMultiholderSelectorInitData(data: any, dataFromRecovery = false): void {
    this.multiholderSelectorInitData = {
      data: data,
      dataFromRecovery: dataFromRecovery
    };
  }

  setEnrollmentInitData(landingOutputData: any): void {
    this.enrollmentInitData = landingOutputData;
  }

  setLoginInitData(enrollmentOutputData: any, portalConfig): void {
    this.loginInitData = {
      ...enrollmentOutputData,
      ...this.getLoginData(portalConfig)
    };
  }

  getLoginData(portalConfig): LoginInitData {
    return {
      loginType: 'implicit',
      clientId: portalConfig.CUSTOM_CONFIG.CLIENT_ID,
      scope: portalConfig.CUSTOM_CONFIG.SCOPES.join(' '),
      redirectUri: portalConfig.CUSTOM_CONFIG.REDIRECT_URI
    };
  }

  setPersonalDataInitData(loginOutputData: LoginOutputData): void {
    this.personalDataInitData = { ...loginOutputData, dni: sessionStorage.getItem('dni') };
  }

  setOtpInitData(personalDataOutputData: any, dataFromRecovery = false): void {
    if (dataFromRecovery) {
      this.otpInitData = {
        customer: {
          name: personalDataOutputData.name,
          surname: personalDataOutputData.surname,
          secondSurname: personalDataOutputData.secondSurname,
          dni: sessionStorage.getItem('dni')
        }
      };
    } else {
      this.otpInitData = personalDataOutputData;
    }
  }

  setPreviousInfoInitData(otpOutputData: any, dataFromRecovery = false): void {
    if (dataFromRecovery) {
      this.previousInfoInitData = {
        customer: {
          name: otpOutputData.name,
          surname: otpOutputData.surname,
          secondSurname: otpOutputData.secondSurname,
          dni: sessionStorage.getItem('dni')
        }
      };
    } else {
      this.previousInfoInitData = otpOutputData;
    }
  }

  setAssociatedBankingInitData(otpOutputData: any, dataFromRecovery = false): void {
    if (dataFromRecovery) {
      this.associatedBankingInitData = {
        customer: {
          name: otpOutputData.name,
          surname: otpOutputData.surname,
          secondSurname: otpOutputData.secondSurname,
          dni: sessionStorage.getItem('dni')
        }
      };
    } else {
      this.associatedBankingInitData = otpOutputData;
    }
  }

  setAssociatedCollaboratorInitData(otpOutputData: any, dataFromRecovery = false): void {
    if (dataFromRecovery) {
      this.associatedCollaboratorInitData = {
        customer: {
          name: otpOutputData.name,
          surname: otpOutputData.surname,
          secondSurname: otpOutputData.secondSurname,
          dni: sessionStorage.getItem('dni')
        }
      };
    } else {
      this.associatedCollaboratorInitData = otpOutputData;
    }
  }

  setNationalityInitData(personalDataOutputData: any, dataFromRecovery = false): void {
    if (dataFromRecovery) {
      this.nationalityInitData = {
        customer: {
          name: personalDataOutputData.name,
          surname: personalDataOutputData.surname,
          secondSurname: personalDataOutputData.secondSurname,
          dni: sessionStorage.getItem('dni')
        }
      };
    } else {
      this.nationalityInitData = personalDataOutputData;
    }
  }

  async setIdvIdentificationInitData(
    nationalityOutputData: any,
    skipBiometricPage: boolean,
    showVerificationErrorPage: boolean,
    dataFromRecovery = false
  ): Promise<void> {
    if (dataFromRecovery) {
      this.idvIdentificationInitData = {
        customer: {
          name: nationalityOutputData.name,
          surname: nationalityOutputData.surname,
          secondSurname: nationalityOutputData.secondSurname,
          dni: sessionStorage.getItem('dni')
        }
      };
    } else {
      this.idvIdentificationInitData = nationalityOutputData;
    }
    this.idvIdentificationInitData.skipBiometricPage = skipBiometricPage;
    this.idvIdentificationInitData.showVerificationErrorPage = showVerificationErrorPage;
  }

  setIdentityCheckInitData(previousOutputData: any, numCheck: number, dataFromRecovery = false): void {
    const customerInfo = dataFromRecovery
      ? {
          name: previousOutputData.name,
          surname: previousOutputData.surname,
          secondSurname: previousOutputData.secondSurname,
          address: previousOutputData.address,
          location: previousOutputData.location,
          dni: sessionStorage.getItem('dni')
        }
      : previousOutputData.customer;
    const externalData = onfidoInitData.externalData;
    if (numCheck === 1) {
      const passportSelected = sessionStorage.getItem('passportSelected');
      externalData.workflow = passportSelected ? 'passport-video' : 'dni-video';
      externalData.steps = [
        {
          type: 'document',
          options: {
            documentTypes: passportSelected
              ? {
                  passport: true
                }
              : {
                  driving_licence: false,
                  passport: false,
                  national_identity_card: {
                    country: 'ESP'
                  },
                  residence_permit: false
                },
            forceCrossDevice: true
          }
        },
        {
          type: 'face',
          options: {
            requestedVariant: 'video',
            useUploader: false,
            photoCaptureFallback: false
          }
        },
        'complete'
      ];

      externalData.syncType = 'UPLOAD_START_CHECK_ASYNC';
      const identityHeader = this.getTraductions();
      externalData.identityHeader = {
        stepName: identityHeader.stepName,
        stepNumber: '3',
        totalSteps: '6',
        headerTitle: identityHeader.headerTitle,
        headerSubtitle: identityHeader.headerSubtitle
      };
    } else {
      externalData.syncType = 'START_CHECK_SYNC';
      delete externalData.customUI;
    }

    externalData.applicantInfo.firstName = customerInfo.name;
    externalData.applicantInfo.lastName = customerInfo.surname;
    if (customerInfo.secondSurname) {
      externalData.applicantInfo.lastName += ' ' + customerInfo.secondSurname;
    }
    externalData.applicantInfo.userId = customerInfo.dni;
    externalData.applicantInfo.solId = previousOutputData.solId;
    externalData.jsonData = JSON.stringify({ numCheck: numCheck, customer: customerInfo });

    this.identityCheckInitData = { externalData: externalData };

    LoggerUtilsComponent.getInstance().debug('[portal-services.ts] obtaining identity-check data:', this.identityCheckInitData);
  }

  getTraductions(): Record<string, string> {
    const language = getCommonLanguage();
    const identityHeader = {
      stepName: '',
      headerTitle: '',
      headerSubtitle: ''
    };

    switch (language) {
      case 'es-ES':
        identityHeader.stepName = 'Identifícate';
        identityHeader.headerTitle = 'Cuenta Online Sabadell';
        identityHeader.headerSubtitle =
          sessionStorage.getItem('currentOwner') == '2' ? 'Únete a la cuenta compartida' : 'Hazte cliente de Banco Sabadell';
        break;
      case 'ca-ES':
        identityHeader.stepName = "Identifica't";
        identityHeader.headerTitle = 'Compte Online Sabadell';
        identityHeader.headerSubtitle =
          sessionStorage.getItem('currentOwner') == '2' ? 'Uneix-te al compte compartit' : 'Fes-te client de Banc Sabadell';
        break;
      case 'en-GB':
        identityHeader.stepName = 'Identify yourself';
        identityHeader.headerTitle = 'Sabadell Online Account';
        identityHeader.headerSubtitle =
          sessionStorage.getItem('currentOwner') == '2' ? 'Attach the shared account' : 'Become a Banco Sabadell customer';
        break;
      default:
        identityHeader.stepName = 'Identifícate';
        identityHeader.headerTitle = 'Cuenta Online Sabadell';
        identityHeader.headerSubtitle =
          sessionStorage.getItem('currentOwner') == '2' ? 'Únete a la cuenta compartida' : 'Hazte cliente de Banco Sabadell';
    }

    return identityHeader;
  }

  setCheckIdvInitData(identityCheckOutputData: any): void {
    const jsonData: Record<string, string> = JSON.parse(identityCheckOutputData.jsonData);
    this.checkIdvInitData = { customer: jsonData.customer, onfidoData: { solId: identityCheckOutputData.solId } };
  }

  getMultiholderSelectorInitData(): any {
    return this.multiholderSelectorInitData;
  }
  getResultsMessagesInitData(): any {
    return this.resultsMessagesInitData;
  }
  getMultiholderInvitationInitData(): any {
    return this.multiholderInvitationInitData;
  }
  getEnrollmentInitData(): any {
    return this.enrollmentInitData;
  }
  getLoginInitData(): any {
    return this.loginInitData;
  }
  getPersonalDataInitData(): any {
    return this.personalDataInitData;
  }
  getOtpInitData(): any {
    return this.otpInitData;
  }
  getPreviousInfoInitData(): any {
    return this.previousInfoInitData;
  }
  getAssociatedBankingInitData(): any {
    return this.associatedBankingInitData;
  }
  getAssociatedCollaboratorInitData(): any {
    return this.associatedCollaboratorInitData;
  }
  getNationalityInitData(): any {
    return this.nationalityInitData;
  }
  getIdvIdentificationInitData(): any {
    return this.idvIdentificationInitData;
  }
  getIdentityCheckInitData(): any {
    return this.identityCheckInitData;
  }
  getOnboardingKYCInitData(): any {
    return this.onboardingKYCInitData;
  }
  getAddressConfirmationInitData(): any {
    return this.addressConfirmationInitData;
  }
  getContractSigningInitData(): any {
    return this.contractSigningInitData;
  }
  getCheckIdvInitData(): any {
    return this.checkIdvInitData;
  }
  getLandingInitData(): any {
    return this.landingInitData;
  }
}
